/**
 * @generated SignedSource<<73ccef8693887cd437424af427c37a43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MetricProgress = "DECREASING" | "INCREASING";
export type MetricType = "CURRENCY" | "NUMBER" | "PERCENTAGE";
export type ObjectiveStatus = "ABANDONED" | "AT_RISK" | "BEHIND" | "COMPLETED" | "NO_STATUS" | "ON_TRACK";
export type ObjectiveVisibility = "PRIVATE" | "PUBLIC";
export type ObjectiveInput = {
  assigneeTeam?: string | null;
  assigneeUser?: string | null;
  contributors?: ReadonlyArray<string | null> | null;
  cycle?: string | null;
  description?: string | null;
  dueDate?: any | null;
  id?: string | null;
  keyResults?: ReadonlyArray<KeyResultInput | null> | null;
  parent?: string | null;
  status?: ObjectiveStatus | null;
  title?: string | null;
  visibility?: ObjectiveVisibility | null;
  weight?: number | null;
};
export type KeyResultInput = {
  assigneeTeam?: string | null;
  assigneeUser?: string | null;
  dueDate?: any | null;
  id?: string | null;
  metricCurrency?: string | null;
  metricCurrent?: number | null;
  metricProgress?: MetricProgress | null;
  metricStart?: number | null;
  metricTarget?: number | null;
  metricType?: MetricType | null;
  order?: number | null;
  title?: string | null;
  weight?: number | null;
};
export type ObjectiveCreateOrEditMutation$variables = {
  objective: ObjectiveInput;
};
export type ObjectiveCreateOrEditMutation$data = {
  readonly Objective_CreateEdit: {
    readonly objective: {
      readonly archived: boolean;
      readonly assigneeTeam: {
        readonly id: string;
        readonly title: string;
      } | null;
      readonly assigneeUser: {
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
        readonly isGuest: boolean;
      } | null;
      readonly contributors: ReadonlyArray<{
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
        readonly isGuest: boolean;
      }>;
      readonly contributorsTeams: ReadonlyArray<{
        readonly id: string;
        readonly title: string;
      }>;
      readonly cycle: {
        readonly id: string;
      } | null;
      readonly description: string | null;
      readonly dueDate: string | null;
      readonly hasAccess: boolean;
      readonly id: string;
      readonly keyResults: ReadonlyArray<{
        readonly assigneeTeam: {
          readonly id: string;
          readonly title: string;
        } | null;
        readonly assigneeUser: {
          readonly email: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly isGuest: boolean;
        } | null;
        readonly dueDate: string | null;
        readonly id: string;
        readonly metricCurrency: string | null;
        readonly metricCurrent: number;
        readonly metricProgress: MetricProgress;
        readonly metricStart: number;
        readonly metricTarget: number;
        readonly metricType: MetricType;
        readonly order: number;
        readonly progress: number;
        readonly title: string;
        readonly weight: number;
      }>;
      readonly parent: {
        readonly cycle: {
          readonly endDate: string | null;
          readonly startDate: string | null;
        } | null;
        readonly id: string;
        readonly level: number;
        readonly title: string;
      } | null;
      readonly progress: number;
      readonly status: ObjectiveStatus;
      readonly title: string;
      readonly visibility: ObjectiveVisibility;
      readonly weight: number;
    };
  } | null;
};
export type ObjectiveCreateOrEditMutation = {
  response: ObjectiveCreateOrEditMutation$data;
  variables: ObjectiveCreateOrEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "objective"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "objective",
    "variableName": "objective"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueDate",
  "storageKey": null
},
v6 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "image",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isGuest",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "assigneeUser",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "assigneeTeam",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "contributors",
  "plural": true,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "contributorsTeams",
  "plural": true,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weight",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Cycle",
  "kind": "LinkedField",
  "name": "cycle",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "level",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "KeyResult",
  "kind": "LinkedField",
  "name": "keyResults",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v5/*: any*/),
    (v7/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricCurrency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricCurrent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricTarget",
      "storageKey": null
    },
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "order",
      "storageKey": null
    },
    (v20/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAccess",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ObjectiveCreateOrEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateEditObjectiveMutation",
        "kind": "LinkedField",
        "name": "Objective_CreateEdit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Objective",
            "kind": "LinkedField",
            "name": "objective",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Objective",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Cycle",
                    "kind": "LinkedField",
                    "name": "cycle",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ObjectiveCreateOrEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateEditObjectiveMutation",
        "kind": "LinkedField",
        "name": "Objective_CreateEdit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Objective",
            "kind": "LinkedField",
            "name": "objective",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Objective",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Cycle",
                    "kind": "LinkedField",
                    "name": "cycle",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "11071508bc17a3e77ba7b14287916e41",
    "id": null,
    "metadata": {},
    "name": "ObjectiveCreateOrEditMutation",
    "operationKind": "mutation",
    "text": "mutation ObjectiveCreateOrEditMutation(\n  $objective: ObjectiveInput!\n) {\n  Objective_CreateEdit(objective: $objective) {\n    objective {\n      id\n      title\n      visibility\n      dueDate\n      assigneeUser {\n        id\n        email\n        image\n        fullName\n        isGuest\n      }\n      assigneeTeam {\n        id\n        title\n      }\n      contributors {\n        id\n        email\n        image\n        fullName\n        isGuest\n      }\n      contributorsTeams {\n        id\n        title\n      }\n      description\n      status\n      archived\n      weight\n      cycle {\n        id\n      }\n      parent {\n        id\n        title\n        level\n        cycle {\n          startDate\n          endDate\n          id\n        }\n      }\n      progress\n      keyResults {\n        id\n        title\n        dueDate\n        assigneeUser {\n          id\n          email\n          image\n          fullName\n          isGuest\n        }\n        assigneeTeam {\n          id\n          title\n        }\n        metricProgress\n        metricType\n        metricCurrency\n        metricStart\n        metricCurrent\n        metricTarget\n        weight\n        order\n        progress\n      }\n      hasAccess\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3599b934c84d148e909b374b24d84a62";

export default node;
